import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { selector } from 'recoil';
import { refreshCoveragePackagesAtom } from '../atoms/refreshCoveragePackagesAtom';
import { currentPackageGroupAtom } from '../atoms/currentPackageGroupAtom';
import { isSavingPackageAtom } from '../atoms/isSavingPackageAtom';

export const coveragePackagesSelector = selector({
    key: 'coveragePackagesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const currentPackageGroup = get(currentPackageGroupAtom);
        const isSavingPackage = get(isSavingPackageAtom);
        get(refreshCoveragePackagesAtom);

        if (!currentProduct || isSavingPackage) {
            return [];
        }

        const { lobCode, fixedId } = currentProduct;

        const packages = await OnlineSalesUnauthenticated.createPackages(
            jobNumber,
            lobCode,
            fixedId,
            currentPackageGroup,
            sessionId,
            !isLoggedOn
        );

        return packages;
    },
    cachePolicy_UNSTABLE: {
        eviction: 'most-recent'
    }
});
